import "./HighlightInputBoutDialog.scss";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import Label from "../1. Core/Controls/Label/Label";
import Button from "../1. Core/Controls/Button/Button";
import CheckBox from "../1. Core/Controls/CheckBox/CheckBox";
import NP, {EventKeyArgs} from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {secondsToTime} from "../10. Battle/Util";
import Select from "../1. Core/Controls/Select/Select";
import TextField from "../1. Core/Controls/TextField/TextField";
import {HIGHLIGHT_STRUCTURE} from "./HIGHLIGHT_STRUCTURE";
import ListBox, {ListBoxItemArgs} from "../1. Core/Controls/ListBox/ListBox";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import {EventTournament, FunnyItem, HighlightRow, IBattle, MMAEvent, SportType} from "../10. Battle/types";
import EditMMAFunnyDialog from "./EditMMAFunnyDialog";
import Menu from "../1. Core/Controls/Menu/Menu";
import {EndBoutDialog} from "./EndBoutDialog";


let moment = require('moment');


const ControlGrapple = ['Arm', 'Leg', 'Other'];
const ControlGround = ['Scrambels', 'Sweeps', 'Other'];


export class HightlightInputBoutDialog extends Dialog {
    private _redLabel: Label;
    private _blueLabel: Label;
    private _roundLabel: Label;
    private _Battle: IBattle;
    private _serverTimeLabel: Label;


    private _timeInterval: any;

    private _startBtn: Button;

    private _mainPointsTbl: HTMLTableElement;
    private _mainPointsNode: HTMLElement;

    private _endBattleBtn: Button;

    private _clearData: Button;
    private _lastEvent: MMAEvent;

    private _offlineCheckBox: CheckBox;
    private _onlineCurrentRound: number;
    private _currentTotalTime: string;
    private _moreAddHLBtns: HTMLElement;
    private _mainViewNode: HTMLElement;

    private _funnyList: ListBox;
    private controlAthleteId: number;
    private _videoStreamLabel: Label;
    private _urlStreamInput: TextField;
    private _startStreamBtn: Button;
    private _stopStreamBtn: Button;
    private _downloadStreamBtn: Button;
    private _StreamId: string;
    private _videoStreamInfoLabel: Label;
    private startStreamDate: Date;
    private _streamTimeId: any;


    _initFields(settings: object) {

        this._Battle = null;

        super._initFields(settings);
        this._lastEvent = null;

        this._AutoDestroy = true;
        this._Mode = 'FullScreen';
        this._Caption = "Highlights - " + NP.escapeHTML(this._Battle.Tournament) + " - " + (this._Battle.Date ? moment(this._Battle.Date).format(NP.getDayFormat()) : "");
        this._CloseOnFrameMouseDown = false;
        this._ShowHeader = true;
        this._ShowCloseButton = true;
        this._ShowButtons = false;
        this._UseSinglePaddingContent = false;
        this._FlexContent = true;

    }

    _render() {
        super._render();
        this.addClass('nopad judge-points-dlg battle-statistics-dialog input-highlight-dialog');

        NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
        NP.addCssClass(this._container, 'dialog__container--fullscreen');


        //****************************Stream controls******************************

        let streamNode = NP.createNode(this._contentNode, 'stream-settings-node');


        this._videoStreamLabel = new Label({
            ParentNode: streamNode,
            Content: NP.RM.getString('StreamUrl')
        });

        this._urlStreamInput = new TextField({
            ParentNode: streamNode,
            Width: 300
        });

        this._startStreamBtn = new Button({
            EvClick: () => this.startStreamClick(),
            RK: 'StartRecord',
            Class: 'app-button--raised',
            ParentNode: streamNode
        })

        this._videoStreamInfoLabel = new Label({
            ParentNode: streamNode,
            Content: NP.RM.getString('VideoStreamRecording'),
            IsVisible: false
        });


        this._stopStreamBtn = new Button({
            EvClick: () => this.stopStreamClick(),
            RK: 'StopRecord',
            Class: 'app-button--raised',
            ParentNode: streamNode,
            IsVisible: false
        })


        this._downloadStreamBtn = new Button({
            EvClick: () => this.downloadStreamClick(),
            RK: 'DownloadBattleVideo',
            Class: 'app-button--raised',
            ParentNode: streamNode
        })

        //*******************************************
        let boutInfoNode = NP.createNode(this._contentNode, 'bout-info ');

        let boutInfoNodeSecondRow = NP.createNode(boutInfoNode, 'bout-info__row highlight-dialog-vs-names');
        this._redLabel = new Label({
            ParentNode: boutInfoNodeSecondRow,
            Class: 'bout-info__row__item bout-info__row__item__red',
            MultiLine: true,
            Content: this._Battle.RedName
        });


        new Button({
            RK: 'ChangeCorners',
            ParentNode: boutInfoNodeSecondRow,
            EvClick: () => {
                NP.showConfirm({
                    RK: 'AreYouS',
                    EvOkButtonClick: async () => {
                        await ServerAPI.post(`/battle/changeCorners/${this._Battle.Id}`);
                        this._Battle = await ServerAPI.get(`/battle/${this._Battle.Id}`);
                        this._blueLabel.setContent(this._Battle.BlueName);
                        this._redLabel.setContent(this._Battle.RedName);
                    }
                }).show();
            }
        })

        this._blueLabel = new Label({
            ParentNode: boutInfoNodeSecondRow,
            Class: 'bout-info__row__item bout-info__row__item__blue',
            MultiLine: true,
            Content: this._Battle.BlueName
        });

        //-------------------------------------
        let roundParent = NP.createNode(boutInfoNode, 'bout-info__row');


        this._startBtn = new Button({
            RK: 'StartView',
            Enabled: true,
            ParentNode: roundParent,
            Class: 'app-button--raised green-btn',
            EvClick: () => this.startBattle()
        });


        this._roundLabel = new Label({
            ParentNode: roundParent,
            Class: 'bout-info__row__item',
            RK: 'Round'
        });


        this._serverTimeLabel = new Label({
            ParentNode: roundParent,
            Class: 'bout-info__row__item',
            Content: '00:00'
        });


        //-------------------------------------

        this._mainViewNode = NP.createNode(this._contentNode, 'hl-main-view');

        this._moreAddHLBtns = NP.createNode(this._mainViewNode, 'more-hl-btns');
        this._mainPointsNode = NP.createNode(this._mainViewNode, 'event-list-for-highlights');
        let flistNode = NP.createNode(this._mainViewNode, 'funny-list-node');
        flistNode.style.width = '350px';
        this._mainPointsTbl = NP.createNode(this._mainPointsNode, '', 'table');

        //---------------------------------

        let extraNode = NP.createNode(this._contentNode, 'action-buttons judge-extra-node');


        this._endBattleBtn = new Button({
            RK: 'BoutEnd',
            Class: 'judge-extra-btn judge-bout-end-btn',
            Width: 150,
            IsVisible: false,
            ParentNode: extraNode,
            EvClick: () => {
                clearTimeout(this._timeInterval);

                this._endBattleBtn.setIsVisible(false);


                (new EndBoutDialog({
                    Battle: this._Battle,
                    LastEvent: this._lastEvent,
                    EndTimeStr: this._currentTotalTime
                })).show();
            }
        });

        this._offlineCheckBox = new CheckBox({
            Content: 'IsOffline',
            ParentNode: extraNode
        });


        this._clearData = new Button({
            RK: 'Clear',
            Width: 150,
            IsVisible: false,
            ParentNode: extraNode,
            EvClick: async () => {
                await ServerAPI.post(`/highlight/${this._Battle.Id}/clearHighlightData`);
                this._startBtn.setEnabled(true);
                this._clearData.setIsVisible(false);
            }
        });

        new Button({
            RK: 'Walkout',
            Class: 'app-button--red app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(this._Battle.Red, 'Walkout')
        });


        new Button({
            RK: 'Walkout',
            Class: 'app-button--blue app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(this._Battle.Blue, 'Walkout')
        });

        this._br(this._moreAddHLBtns)


        new Button({
            Content: 'ToT',
            Class: ' app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'ToT')
        });

        this._br(this._moreAddHLBtns)


        new Button({
            RK: 'Staredown',
            Class: ' app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'Staredown')
        });

        this._br(this._moreAddHLBtns)


        new Button({
            RK: 'Stat',
            Class: ' app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'Stat')
        });

        this._br(this._moreAddHLBtns)

        new Button({
            RK: 'ShowRespect',
            Class: 'app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'ShowRespect')
        });

        this._br(this._moreAddHLBtns)


        new Button({
            Content: 'Repeat',
            Class: 'app-button--raised green-btn',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'Repeat')
        });

        this._br(this._moreAddHLBtns)


        new Button({
            RK: 'Other',
            Class: 'judge-extra-btn app-button--red app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightOther(this._Battle.Red)
        });


        new Button({
            RK: 'Other',
            Class: 'app-button--blue app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightOther(this._Battle.Blue)
        });

        new Button({
            RK: 'Gong',
            Class: 'app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'Gong')
        });

        let re = new Button({
            RK: 'RoundEnd',
            Class: 'app-button--raised green-btn',
            Width: 125,
            ParentNode: this._moreAddHLBtns,
            EvClick: () => this.addHighlightEx(null, 'RoundEnd')
        });

        re.getRoot().style.marginLeft = '12px'

        this._br(this._moreAddHLBtns)

        new Button({
            Content: 'Winning',
            Class: 'app-button--red app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            Data: 0,
            EvClick: (btn: Button) => {
                let cnt = btn.getData() + 1;
                btn.setData(cnt)
                btn.setContent('Winning ' + cnt)
                this.addHighlightEx(this._Battle.Red, 'Winning')
            }
        });


        new Button({
            Content: 'Winning',
            Class: 'app-button--blue app-button--raised',
            Width: NP.isTouchDevice() ? 75 : 125,
            ParentNode: this._moreAddHLBtns,
            Data: 0,
            EvClick: (btn: Button) => {
                let cnt = btn.getData() + 1;
                btn.setData(cnt)
                btn.setContent('Winning ' + cnt)
                this.addHighlightEx(this._Battle.Blue, 'Winning')
            }
        });


        this.getOkButton().setIsVisible(false);

        NP.setIsVisible([this._mainViewNode], false);

        this._funnyList = new ListBox({
            ParentNode: flistNode,
            EvDeletedClick: (s: object, e: ListBoxItemArgs) => {
                ServerAPI.post(`/highlight/${e.Item.getValue().Id}/removeHighlightFunny`);
                this._funnyList.removeItem(e.Item)
            },
            EvItemClick: (s: object, e: ListBoxItemArgs) => {
                let hlitem = e.Item.getValue() as FunnyItem;

                (new EditMMAFunnyDialog({
                    Event: hlitem,
                    EvSaved: () => {
                        e.Item.setContent(`${moment(hlitem.HighlightTS.split("+")[0]).format("HH:mm:ss")} : ${hlitem.Action}`)
                    }
                })).show()

            }
        });

        this.refresh()
    }

    async refresh() {
        let streamInfo = await ServerAPI.get(`/video/getCurrentStreamId/${this._Battle.Id}`) as {
            streamId: string,
            startDate: string,
            streamUrl: string
        }

        if (streamInfo) {
            NP.setIsVisible([this._startStreamBtn, this._downloadStreamBtn], false)

            this._urlStreamInput.setValue(streamInfo.streamUrl)
            this._urlStreamInput.setEnabled(false)

            NP.setIsVisible([this._stopStreamBtn, this._videoStreamInfoLabel], true)


            this._StreamId = streamInfo.streamId;
            this.startStreamDate = moment(streamInfo.startDate).toDate();
            this._streamTimeId = setTimeout(() => this.recalcStreamDate(), 1000);

        } else if (this._Battle.VideoUrl) {
            NP.setIsVisible([this._urlStreamInput, this._startStreamBtn, this._stopStreamBtn], false)
            this._downloadStreamBtn.setIsVisible(true);
        } else {
            //can start stream
            this._downloadStreamBtn.setIsVisible(false);
        }


        if (this._Battle.EventId) {
            let ev = await ServerAPI.get<EventTournament>(`/t-events/${this._Battle.EventId}`)
            if (ev?.VideoStreamUrl)
                this._urlStreamInput.setValue(ev.VideoStreamUrl)
        }
    }

    addHighlightOther(athleteId: number) {
        this.addHighlightEx(athleteId, 'Other');

        // (new Dialog({
        // 	Content: new TextField({}),
        // 	Caption: 'Enter action',
        // 	ShowHeader: true,
        // 	AutoDestroy: true,
        // 	EvOkButtonClick: async (dlg: Dialog) =>
        // 	{
        // 		let action = dlg.getContent().getValue();
        // 		if (action)
        //
        // 	}
        // })).show()
    }

    async addHighlightEx(athleteId: number, action: string) {
        let item = await ServerAPI.post(`/highlight/${this._Battle.Id}/addHighlightFunny`, {
            AthleteId: athleteId,
            Action: action,
            Round: this._onlineCurrentRound || 1
        }) as FunnyItem
        this.addFunnyItem(item);
    }


    async updateTimeLabel() {

        if (!this.isLive())
            return;

        let info = await ServerAPI.get(`/highlight/${this._Battle.Id}/getOnlineBattleInfo${this._lastEvent ? '?lastLoadedEvent=' + this._lastEvent.EventOrder : ''}`, false) as {
            Events: HighlightRow[],
            CurrentTime: number,
            CurrentTotalTime: number;
            CurrentRound: number;
            HighlightStartTS: number;
            HighlightCurrentTS: number;
        }

        if (!this.isLive())
            return;

        if (info.CurrentTime) {
            info.CurrentTotalTime = info.CurrentTotalTime / 1000;
            if (info.CurrentRound > 1)
                info.CurrentTotalTime += (info.CurrentRound - 1) * this._Battle.RoundLength * 60;

            this._currentTotalTime = secondsToTime(info.CurrentTotalTime);
            this._serverTimeLabel.setContent(secondsToTime(info.CurrentTime / 1000) + " (" + this._currentTotalTime + ")");
            this._onlineCurrentRound = info.CurrentRound;

            if (info.CurrentRound)
                this._roundLabel.setContent(NP.RM.getString("Round") + " " + info.CurrentRound);
        }

        let round = this._lastEvent ? this._lastEvent.Round : null;
        let isRedControl = null
        for (let ev of info.Events) {
            if (round && round != ev.Round) {
                let cell = this._mainPointsTbl.insertRow().insertCell();
                cell.setAttribute('colspan', '2');
                NP.createNode(cell, 'round-divider');

                cell = this._mainPointsTbl.insertRow().insertCell();
                cell.setAttribute('colspan', '2');
                cell.style.textAlign = 'center';
                cell.innerText = NP.RM.getString("Round") + " " + ev.Round
                this.controlAthleteId = null;
            }

            if (ev.GrappleStart)
            {
                if (isRedControl == null)
                    isRedControl = ev.ActionAthleteId == this._Battle.Red
            }

            if (ev.GroundStart)
            {
                if (isRedControl == null)
                    isRedControl = ev.ActionAthleteId == this._Battle.Red
            }

            if (!ev.GroundStart && !ev.GrappleStart)
            {
                isRedControl = null
            }

            if (ev.Action == "Control")
            {
                isRedControl = ev.ActionAthleteId == this._Battle.Red
            }

            this.renderEvent(ev, isRedControl);
            round = ev.Round;
        }

        if (!this._offlineCheckBox.getChecked())
            this._mainPointsNode.scrollTop = this._mainPointsNode.scrollHeight;

        if (info.Events.length)
            this._lastEvent = info.Events[info.Events.length - 1];

        this._timeInterval = setTimeout(() => this.updateTimeLabel(), 1000);
    }


    pause() {
        clearTimeout(this._timeInterval);
        this._startBtn.setEnabled(true);
    }


    renderEvent(ev: HighlightRow, isRedControl: boolean | null) {
        let color = ev.ActionAthleteId == this._Battle.Red ? NP.RED_COLOR : NP.BLUE_COLOR;
        let row = this._mainPointsTbl.insertRow()

        row.style.color = color;
        let cell1 = row.insertCell();
        let posNode = NP.createNode(row.insertCell(), 'highlight-event__btns', 'div');

        let lbl: Label
        if (ev.GroundStart)
        {
            lbl = new Label({
                ParentNode: posNode,
                Content: 'Ground',

            })
        }
        else if (ev.GrappleStart)
        {
            lbl = new Label({
                ParentNode: posNode,
                Content: 'Grapple'
            });
        }

        if (lbl) {
            if (isRedControl != null) {
                lbl.getRoot().style.color = isRedControl ? NP.RED_COLOR : NP.BLUE_COLOR;
            } else
                lbl.getRoot().style.color = 'black'
        }

        let btnNode = NP.createNode(row.insertCell(), 'highlight-event__btns', 'div');
        this.updateCellEvent(cell1, ev, null);
        this.addEvent(cell1, 'click', () => this.editEvent(cell1, ev, btnNode))
        let exText = this.doCreateHighlightButton(ev, btnNode)

        if (exText)
            (cell1.firstChild as HTMLElement).innerText += exText;

        if (ev.GrappleStart == null && ev.GroundStart == null)
            this.controlAthleteId = null;
    }

    updateCellEvent(cell: HTMLElement, ev: HighlightRow, btnNode: HTMLElement) {
        cell.innerHTML = `<div  class="highlight-event" >${ev.Time || ''} ${ev.Action} ${ev.Zone || ''} => ${ev.Answer || ''} ${ev.AutoPoint ? '(' + ev.AutoPoint + ')' : ''}</div>`;
        if (btnNode) {
            btnNode.innerHTML = '';
            this.doCreateHighlightButton(ev, btnNode)
        }
    }

    doCreateHighlightButton(ev: HighlightRow, btnNode: HTMLElement) {



        let btn4 = new Button({
            ParentNode: btnNode,
            Width: NP.isTouchDevice() ? 50 : 70,
            Class: ev.ManualPoint == 4 ? 'app-button--raised app-button--red' : 'app-button--raised green-btn',
            Content: '4',
            EvClick: async (btn: Button) => {
                if (ev.ManualPoint && ev.ManualPoint == 4) {
                    ev.ManualPoint = null;
                    btn.removeClass('app-button--red')
                    btn.addClass('green-btn')
                } else {
                    btn35.removeClass('app-button--red')
                    btn35.addClass('yellow-btn')

                    ev.ManualPoint = 4;
                    btn.addClass('app-button--red')
                    btn.removeClass('green-btn')
                }

                await ServerAPI.post(`/highlight/${ev.EventOrder}/setHighlightManualPoint${ev.ManualPoint ? '?points=' + ev.ManualPoint : ''}`)
            }
        })

        let btn35 = new Button({
            ParentNode: btnNode,
            Width: NP.isTouchDevice() ? 50 : 70,
            Class: ev.ManualPoint == 3.5 ? 'app-button--raised app-button--red' : 'app-button--raised yellow-btn',
            Content: '3.5',
            EvClick: async (btn: Button) => {
                if (ev.ManualPoint && ev.ManualPoint == 3.5) {
                    ev.ManualPoint = null;
                    btn.removeClass('app-button--red')
                    btn.addClass('yellow-btn')
                } else {
                    btn4.removeClass('app-button--red')
                    btn4.addClass('green-btn')

                    ev.ManualPoint = 3.5;
                    btn.addClass('app-button--red')
                    btn.removeClass('yellow-btn')
                }

                await ServerAPI.post(`/highlight/${ev.EventOrder}/setHighlightManualPoint${ev.ManualPoint ? '?points=' + ev.ManualPoint : ''}`)
            }
        })


        let data = (HIGHLIGHT_STRUCTURE as any)[ev.Action];
        if (data) {
            let items = data[ev.Zone] || data.Other;
            if (items) {
                items.sort();
                new Select({
                    ParentNode: btnNode,
                    Width: NP.isTouchDevice() ? 150 : 200,
                    Height: 22,
                    Value: ev.HLDesc,
                    Class: (ev.Action == 'Takedown' || ev.Action == 'Transition' || ev.Action == 'Submission') && !ev.HLDesc ? 'alerts-border' : '',
                    Items: [{Content: '', Value: null}, ...items.map((i: string) => ({
                        Content: i,
                        Value: i
                    }))],
                    EvItemSelected: async (select: Select) => {
                        ev.HLDesc = select.getValue();
                        select.removeClass('alerts-border');

                        await ServerAPI.post(`/highlight/${this._Battle.Id}/setHighlightDesc?desc=${select.getValue()}&evKey=${ev.EventOrder}`)
                    }
                });
            }
        }

        if (ev.Action == 'Control' && ev.Answer == 'Hit') {

            if (this.controlAthleteId == null)
                this.controlAthleteId = ev.ActionAthleteId;
            else {
                if (this.controlAthleteId != ev.ActionAthleteId) {
                    this.controlAthleteId = ev.ActionAthleteId;
                    //reversal

                    new Select({
                        ParentNode: btnNode,
                        Width: NP.isTouchDevice() ? 150 : 200,
                        Height: 22,
                        Value: ev.HLDesc,
                        Class: ev.HLDesc ? '' : 'alerts-border',
                        Items: (ev.GroundStart ? ControlGround : ControlGrapple).map(item => ({
                            Content: item,
                            Value: item
                        })),
                        EvItemSelected: async (select: Select) => {
                            ev.HLDesc = select.getValue();
                            select.removeClass('alerts-border');
                            await ServerAPI.post(`/highlight/${this._Battle.Id}/setHighlightDesc?desc=${select.getValue()}&evKey=${ev.EventOrder}`)
                        }
                    });

                    return ' (Reversal)'
                }
            }
        }

    }


    async startBattle() {
        this._lastEvent = null;
        this._roundLabel.setContent(NP.RM.getString("Round"));

        NP.setIsVisible([this._endBattleBtn, this._mainViewNode], true)
        this._clearData.setIsVisible(false);
        this._startBtn.setEnabled(false);

        ServerAPI.get(`/highlight/getHighlightFunny/${this._Battle.Id}`).then((items: FunnyItem[]) => {
            items.forEach(item => this.addFunnyItem(item))
        });

        await ServerAPI.post(`/highlight/${this._Battle.Id}/startMMAHighlight`)
        this._timeInterval = setTimeout(() => this.updateTimeLabel(), 1000);

        this._contentDomNode.focus()
    }

    addFunnyItem(item: FunnyItem) {
        this._funnyList.addItem({
            Content: `${moment(item.HighlightTS.split("+")[0]).format("HH:mm:ss")} : ${item.Action}`,
            Value: item,
            ShowDeleteButton: true,
            Class: item.AthleteId == this._Battle.Red ? 'app-list-item--red' : (item.AthleteId == this._Battle.Blue ? 'app-list-item--blue' : '')
        })
    }


    hide() {
        clearTimeout(this._timeInterval);
        super.hide();
    }

    addkbActions() {

        if (this._Battle.Type == SportType.MMA)
            return []

        return [
            {Content: "Jeb", Value: "Jeb"},
            {Content: "Cross", Value: "Cross"},
            {Content: "Hook L", Value: "Hook L"},
            {Content: "Hook R", Value: "Hook R"},
            {Content: "Uppercut L", Value: "Uppercut L"},
            {Content: "Uppercut R", Value: "Uppercut R"},
        ]
    }

    editEvent(cell: HTMLElement, event: MMAEvent, btnNode: HTMLElement) {
        let dlg = new Dialog({
            ShowHeader: true,
            AutoDestroy: true,
            ShowButtons: true,
            Caption: NP.RM.getString('EditEvent'),
            Content: [
                new Select({
                    FloatingLabel: 'Action',
                    Items: [
                        {Content: "Punch", Value: "Punch"},
                        {Content: "Kick", Value: "Kick"},
                        {Content: "Elbow", Value: "Elbow"},
                        {Content: "Knee", Value: "Knee"},
                        {Content: "Takedown", Value: "Takedown"},
                        {Content: "Transition", Value: "Transition"},
                        {Content: "Submission", Value: "Submission"},
                        {Content: "Control", Value: "Control"},
                        ...this.addkbActions()
                    ],
                    Value: event.Action
                }),
                new Select({
                    FloatingLabel: 'Zone',
                    Items: [
                        {Content: "P1", Value: "P1"},
                        {Content: "P2", Value: "P2"},
                        {Content: "P3", Value: "P3"},
                        {Content: "P4", Value: "P4"},
                        {Content: "P5", Value: "P5"},
                        {Content: "P6", Value: "P6"}
                    ],
                    Value: event.Zone
                }),
                new Select({
                    FloatingLabel: 'Answer',
                    Items: [
                        {Content: "Block", Value: "Block"},
                        {Content: "Bobbing", Value: "Bobbing"},
                        {Content: "Footwork", Value: "Footwork"},
                        {Content: "Slip", Value: "Slip"},
                        {Content: "Grapple", Value: "Grapple"},
                        {Content: "Hit", Value: "Hit"},
                        {Content: "Miss", Value: "Miss"},
                        {Content: "CriticalPunch", Value: "CriticalPunch"},
                        {Content: "Knockdown", Value: "Knockdown"},
                    ],
                    Value: event.Answer
                }),

                new TimeEdit({
                    ParentNode: this._contentNode,
                    FloatingLabel: NP.RM.getString('Time'),
                    FontImage: NP.FontImages.url,
                    Value: event.Time,
                    Mode: TimeEditMode.Full
                }),

                new TextField({
                    ParentNode: this._contentNode,
                    FloatingLabel: NP.RM.getString('WorldTime'),
                    FontImage: NP.FontImages.url,
                    Value: event.ActionTS
                })
            ],
            EvOkButtonClick: async () => {
                event.Action = dlg.getContent()[0].getValue();
                event.Zone = dlg.getContent()[1].getValue();
                event.Answer = dlg.getContent()[2].getValue();

                event.Time = dlg.getContent()[3].getValue();
                event.ActionTS = dlg.getContent()[4].getValue();

                await ServerAPI.post(`/mma/updateEventWithoutGround`, event);

                this.updateCellEvent(cell, event as HighlightRow, btnNode);
            }
        });

        let deleteBtn = new Button({
            RK: 'Delete',
            EvClick: () => {
                NP.showConfirm({
                    RK: 'AreYouS',
                    EvOkButtonClick: async () => {
                        await ServerAPI.delet(`/mma/event/${event.EventOrder}`);
                        NP.removeFromParent(cell.parentNode);
                        dlg.hide();
                    }
                })
            }
        })

        deleteBtn.putToNode(dlg.getButtonsNode(), dlg.getCancelButton().getRoot());
        deleteBtn.getRoot().style.marginRight = 'auto';

        dlg.show();
    }

    async startStreamClick() {
        if (!this._urlStreamInput.getValue().trim()) {
            NP.showMessage({Content: 'Stream url is empty'})
            return;
        }

        if (!this._urlStreamInput.getValue().startsWith("http") && !this._urlStreamInput.getValue().startsWith("rtmp")) {
            NP.showMessage({Content: 'Url stream must start with http or rtmp'})
            return;
        }

        this._urlStreamInput.setEnabled(false)
        this._stopStreamBtn.setIsVisible(true)

        this._videoStreamInfoLabel.setContent(NP.RM.getString('VideoStreamRecording') + '00:00');

        this._videoStreamInfoLabel.setIsVisible(true);

        NP.setIsVisible([this._startStreamBtn, this._downloadStreamBtn], false)

        this._StreamId = await ServerAPI.post(`/video/startSaveBattleStream/${this._Battle.Id}`, this._urlStreamInput.getValue().trim() as any)

        this._streamTimeId = setTimeout(() => this.recalcStreamDate(), 1000);
    }

    async recalcStreamDate() {
        if (!this.isLive())
            return;

        if (!this.startStreamDate) {
            let log = await ServerAPI.get(`/video/getCurrentLog/${this._StreamId}`) as string;
            if ((log + '').indexOf('[download] Destination') > -1 || (log + '').indexOf('Metadata:') > -1)
                this.startStreamDate = new Date();
        } else {
            let t = new Date().getTime() - this.startStreamDate.getTime();
            this._videoStreamInfoLabel.setContent(NP.RM.getString('VideoStreamRecording') + secondsToTime(t / 1000));
        }

        this._streamTimeId = setTimeout(() => this.recalcStreamDate(), 1000);
    }

    private stopStreamClick() {
        if (this._stopStreamBtn.getMenu())
            return;

        NP.showConfirm({
            Content: 'Are you sure?',
            EvOkButtonClick: async () => {
                clearTimeout(this._streamTimeId);
                this._streamTimeId = null;

                this.startStreamDate = null;

                this._stopStreamBtn.setMenu(new Menu({
                    Items: [{Content: 'Kill'}],
                    EvItemSelected: async () => {
                        await ServerAPI.post(`/video/killSaveStream/${this._StreamId}`);
                    }
                }))

                await ServerAPI.post(`/video/stopSaveStream/${this._StreamId}`, null, false);
                this._downloadStreamBtn.setIsVisible(true);
                this._stopStreamBtn.setIsVisible(false);
                this._stopStreamBtn.setMenu(null)
            }
        });
    }

    _onCancelButtonClick() {
        if (this._streamTimeId) {
            NP.showConfirm({
                Content: NP.RM.getString('CloseTheStreamConfirm'),
                EvOkButtonClick: () => this.hide()
            });
        } else
            this.hide();
    }

    private downloadStreamClick() {
        NP.downloadFile(`/ui-api/video/downloadBattleVideoFile/${this._Battle.Id}`);
    }

    _onKeyPress(sender: Dialog, args: EventKeyArgs) {
        if (args.Event.keyCode == NP.Key.Space)
            this._offlineCheckBox.setChecked(!this._offlineCheckBox.getChecked(), true)
    }
}

